import React from "react";
import _ from "lodash";
import { FieldArray, useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import {
  FormArraySelectField,
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import { InputAdornment } from "@material-ui/core";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import {
  CustomArraySelectField,
  CustomArrayTextField,
} from "../../../../../partials/content/Forms";

function ItemsCondition(props) {
  const {
    values,
    touched,
    errors,
    setFieldValue,
    handleBlur,
    handleChange,
  } = useFormikContext();
  return (
    <FieldArray name="itemsCondition">
      {({ push, remove }) => (
        <React.Fragment>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="card">
                <Table borderless size="sm" responsive="xl">
                  <thead className="text-center">
                    <tr>
                      <th style={{ width: "25%" }}>Item Name</th>
                      <th style={{ width: "15%" }}>Condition Type</th>
                      <th style={{ width: "10%" }}>Qty</th>
                      <th style={{ width: "10%" }}>Unit</th>
                      <th style={{ width: "35%" }}>Note</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values.itemsCondition && values.itemsCondition.length > 0
                      ? values.itemsCondition.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <tr>
                                <td>
                                  <FormOutlinedNoMarginTextField
                                    value={`${item.itemCode} ${item.itemName}`}
                                    InputProps={{
                                      startAdornment:
                                        item.itemType > 0 ? (
                                          <InputAdornment position="start">
                                            <BootstrapTooltip
                                              title={item.itemTypeName}
                                            >
                                              <i
                                                className={
                                                  item.itemType === 1
                                                    ? "fas fa-boxes text-success"
                                                    : item.itemType === 2
                                                    ? "fas fa-tools text-primary"
                                                    : item.itemType === 3
                                                    ? "fas fa-building text-info"
                                                    : item.itemType === 4
                                                    ? "fas fa-boxes text-warning"
                                                    : item.itemType === 5
                                                    ? "fas fa-boxes text-danger"
                                                    : null
                                                }
                                              ></i>
                                            </BootstrapTooltip>
                                          </InputAdornment>
                                        ) : null,
                                      readOnly: true,
                                    }}
                                  />
                                </td>
                                <td>
                                  <FormArraySelectField
                                    arrayPropName="itemsCondition"
                                    propName="conditionType"
                                    index={index}
                                    margin="none"
                                    options={[
                                      {
                                        label: "Defect",
                                        value: 1,
                                      },
                                      {
                                        label: "Reject",
                                        value: 2,
                                      },
                                    ]}
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="itemsCondition"
                                    index={index}
                                    propName="qty"
                                    quantityField
                                    margin="none"
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="itemsCondition"
                                    index={index}
                                    propName="uomName"
                                    margin="none"
                                    readonly
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="itemsCondition"
                                    index={index}
                                    propName="note"
                                    margin="none"
                                  />
                                </td>
                                <td>
                                  <td
                                    style={{ whiteSpace: "nowrap" }}
                                    className="text-center"
                                  >
                                    <BootstrapTooltip title="Split Condition">
                                      <button
                                        type="button"
                                        className="btn btn-icon btn-label-info btn-md 
                                            btn-circle mx-1"
                                        onClick={() => {
                                          const itemsCondition = [
                                            ...values.itemsCondition,
                                          ];
                                          itemsCondition[
                                            index
                                          ].itemsConditionSplit.push({
                                            purchaseOrderID:
                                              item.purchaseOrderID,
                                            purchaseOrderItemID:
                                              item.purchaseOrderItemID,
                                            itemMovementID: 0,
                                            vendorID: 0,
                                            receivedWarehouseID:
                                              item.receivedWarehouseID,
                                            conditionType: 1,
                                            itemID: item.itemID,
                                            itemType: item.itemType,
                                            itemTypeName: item.itemTypeName,
                                            varCode: item.varCode,
                                            itemCode: item.itemCode,
                                            itemName: item.itemName,
                                            qty: 0,
                                            uomID: item.uomID,
                                            uomName: item.uomName,
                                            note: "",
                                            splitInd: true,
                                          });
                                          setFieldValue(
                                            "itemsCondition",
                                            itemsCondition
                                          );
                                        }}
                                      >
                                        <i className="fas fa-code-branch"></i>
                                      </button>
                                    </BootstrapTooltip>
                                  </td>
                                </td>
                              </tr>
                              {item.itemsConditionSplit &&
                              item.itemsConditionSplit.length > 0
                                ? item.itemsConditionSplit.map(
                                    (itemSplit, indexSplit) => {
                                      return (
                                        <React.Fragment key={indexSplit}>
                                          <tr>
                                            <td></td>
                                            <td>
                                              <CustomArraySelectField
                                                arrayName="itemsCondition"
                                                arrayName2="itemsConditionSplit"
                                                propertyName="conditionType"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                index={index}
                                                index2={indexSplit}
                                                value={values}
                                                touched={touched}
                                                errors={errors}
                                                options={[
                                                  {
                                                    label: "Defect",
                                                    value: 1,
                                                  },
                                                  {
                                                    label: "Reject",
                                                    value: 2,
                                                  },
                                                ]}
                                              />
                                            </td>
                                            <td>
                                              <CustomArrayTextField
                                                arrayName={`itemsCondition[${index}].itemsConditionSplit`}
                                                inputType="number"
                                                propertyName="qty"
                                                margin="none"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                index={indexSplit}
                                                value={itemSplit}
                                                touched={touched}
                                                errors={errors}
                                              />
                                            </td>
                                            <td>
                                              <CustomArrayTextField
                                                arrayName={`itemsCondition[${index}].itemsConditionSplit`}
                                                propertyName="uomName"
                                                margin="none"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                index={indexSplit}
                                                value={itemSplit}
                                                touched={touched}
                                                errors={errors}
                                                endAdornment={{
                                                  readOnly: true,
                                                }}
                                              />
                                            </td>
                                            <td>
                                              <CustomArrayTextField
                                                arrayName={`itemsCondition[${index}].itemsConditionSplit`}
                                                propertyName="note"
                                                margin="none"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                index={indexSplit}
                                                value={itemSplit}
                                                touched={touched}
                                                errors={errors}
                                              />
                                            </td>
                                            <td>
                                              <td
                                                style={{ whiteSpace: "nowrap" }}
                                                className="text-center"
                                              >
                                                <BootstrapTooltip title="Delete Split Condition">
                                                  <button
                                                    type="button"
                                                    className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                                    onClick={() => {
                                                      let itemsConditionSplit = [];
                                                      itemsConditionSplit = [
                                                        ...item.itemsConditionSplit,
                                                      ];
                                                      itemsConditionSplit = _.remove(
                                                        itemsConditionSplit,
                                                        function(
                                                          value,
                                                          indexArr
                                                        ) {
                                                          return (
                                                            indexSplit !==
                                                            indexArr
                                                          );
                                                        }
                                                      );
                                                      setFieldValue(
                                                        `itemsCondition[${index}].itemsConditionSplit`,
                                                        itemsConditionSplit
                                                      );
                                                    }}
                                                  >
                                                    <i className="fas fa-trash-alt"></i>
                                                  </button>
                                                </BootstrapTooltip>
                                              </td>
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      );
                                    }
                                  )
                                : null}
                            </React.Fragment>
                          );
                        })
                      : null}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </FieldArray>
  );
}

export default ItemsCondition;
